import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProjectManagerService } from '../services/project-manager.service';
import { Project } from '../classes/project';
import { SalesDashboardService } from '../services/sales-dashboard.service';
import { element } from 'protractor';
import { SnapShotService } from '../services/snap-shot.service';
import { ModalImageViewComponent } from '../modal-image-view/modal-image-view.component';

@Component({
  selector: 'app-modal-image-manager',
  templateUrl: './modal-image-manager.component.html',
  styleUrls: ['./modal-image-manager.component.scss']
})
export class ModalImageManagerComponent implements OnInit {

  private projects: Project[];
  selectedProjectImages: any = [];
  projectName: string;
  private checkedImagesMap: Object = {};
  private projectId: any;
  constructor(
    public dialogRef: MatDialogRef<ModalImageManagerComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public projectManagerService: ProjectManagerService,
    private salesDashboardService: SalesDashboardService,
    private snapShotService: SnapShotService
  ) {
    this.salesDashboardService.changeSelectedProject.subscribe(value => {
      this.projectName = value.projectName;
      this.selectedProjectImages = value.snapshotsProTools;
      this.projectId = value.id;
    })
  }


  ngOnInit() {
  }

  test(i, img) {
    if (this.checkedImagesMap[i]) {
      delete this.checkedImagesMap[i];
    }
    else {
      this.checkedImagesMap[i] = img;
    }
  }

  deleteImg() {
    let projectId = this.projectManagerService.getCurrentProjectId();
    let imgToDelete: Array<any> = [];
    for (let img in this.checkedImagesMap) {
      imgToDelete.push(this.checkedImagesMap[img]);
    }
    imgToDelete.forEach(element => {
      this.snapShotService.deleteSnapShot(element.imgUrl).subscribe(res => console.log(res));
      let i = this.selectedProjectImages.findIndex(proj => proj.imgUrl === element.imgUrl);
      this.selectedProjectImages.splice(i, 1);
    })
    for (let img in this.checkedImagesMap) {
      delete this.checkedImagesMap[img];
    }
    this.projectManagerService.updateProjectItem(this.projectId, "snapshotsProTools", this.selectedProjectImages).subscribe(res => { this.snapShotService.setSnapshotsProTools(res.snapshotsProTools) });

  }

  openImage(img){
    this.dialog.open(ModalImageViewComponent, {
      width: '60%'
    });
    let openedImg : object ={};
    openedImg["imgName"] = img.imgName;
    openedImg["imgUrl"] = img.imgUrl;
    openedImg["imgNotes"] = img.imgNotes;

    this.salesDashboardService.openImgModal(openedImg);

  }

  closeDialog() {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/modal-image-manager/modal-image-manager.component.ts